import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useApi } from "./useApi.js";
import { ui } from "../store/uiStore.js";

// Invia una singola ricevuta al socio via WhatsApp seguendo il giro coda
// (backend: genera PDF → xfiles → accoda → dispatch con finestra/redirect/lock).
export interface SendReceiptArgs {
  receiptId: string;
  partnerId: string;
  fullName: string;
  cells: string[];
  period: string;
  settled: boolean;
}

export function useReceiptWhatsApp() {
  const { call } = useApi();
  const { t } = useTranslation();

  return useCallback(
    async (args: SendReceiptArgs) => {
      try {
        const r = await call<{ sent?: number; waitingWindow?: number; running?: boolean }>(
          "/api/v1/whatsapp/queues/from-receipt",
          { method: "POST", body: args, silent: true }
        );
        if (r?.running) ui.toast(t("receipts.wa.queued"), "info");
        else if ((r?.waitingWindow ?? 0) > 0 && !(r?.sent ?? 0)) ui.toast(t("receipts.wa.window"), "info");
        else ui.toast(t("receipts.wa.sent"), "success");
      } catch (e) {
        const err = e as { status?: number; message?: string };
        ui.toast(err.status === 400 ? err.message ?? t("receipts.wa.noPhone") : t("common.error"), "error");
      }
    },
    [call, t]
  );
}
